
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Volsawagenventoonrent() {



  const cardData =
  {
    keyword: 'Volkswagen Vento On Rent in Pune',
    heading: 'AB Ghule Cabs: Volkswagen Vento On Rent in Pune',
    headingDescription: 'AB Ghule Cabs offers the Volkswagen Vento on rent in Pune, providing a perfect blend of comfort, style, and performance for your travels. Whether you are planning a business trip, family outing, or simply need a car for a special occasion, our well-maintained Volkswagen Vento ensures a smooth and enjoyable ride. With affordable rates, experienced drivers, and exceptional customer service, we make your journey stress-free and comfortable.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Volkswagen Vento on Rent in Pune',

    "topPlaces": [
  {
    title: "Stylish and Comfortable Ride",
    description: "The Volkswagen Vento offers a refined and stylish ride, with spacious interiors and plush seating. Whether you're traveling for business or leisure, the Vento ensures a comfortable experience for all passengers."
  },
  {
    title: "Fuel-Efficient and Eco-Friendly",
    description: "The Vento is known for its fuel efficiency, making it an ideal choice for long-distance travel. It provides a great balance of performance and economy, ensuring a smooth ride without compromising on fuel consumption."
  },
  {
    title: "Affordable and Transparent Pricing",
    description: "At AB Ghule Cabs, we offer competitive pricing for Volkswagen Vento rentals with no hidden charges. Our transparent pricing ensures that you know the total cost upfront, making it easy to plan your budget."
  },
  {
    title: "Well-Maintained Vehicles",
    description: "All our Volkswagen Vento vehicles are regularly maintained and serviced to meet high standards of safety and comfort. We ensure that the vehicle is in top condition, giving you peace of mind during your travels."
  },
  {
    title: "Professional and Experienced Drivers",
    description: "Our experienced drivers are well-versed in navigating Pune and its surroundings. They are trained to provide safe, courteous, and timely service, ensuring that you reach your destination without any hassle."
  },
  {
    title: "Ideal for Business and Leisure Travel",
    description: "The Volkswagen Vento is a versatile vehicle, making it ideal for both professional and personal use. Whether you’re heading to a business meeting, airport, or planning a day trip, the Vento provides a premium driving experience."
  },
  {
    title: "Modern Features and Technology",
    description: "The Vento is equipped with modern features, including an advanced infotainment system, air conditioning, power steering, and more, ensuring a smooth and enjoyable ride for all passengers."
  },
  {
    title: "Flexible Rental Packages",
    description: "We offer flexible rental options for daily, weekly, and long-term rentals, allowing you to choose a package that suits your needs. Whether you need a car for a few hours or several days, we have affordable options for you."
  },
  {
    title: "24/7 Availability",
    description: "AB Ghule Cabs provides 24/7 availability, so whether you need a car for an early morning airport pickup or a late-night drop, we are always ready to serve you."
  },
  {
    title: "Easy Booking Process",
    description: "Booking your Volkswagen Vento with AB Ghule Cabs is easy and convenient. You can book your ride online or by phone, ensuring a smooth reservation process and securing your travel plans in advance."
  }
],


services: [
    {
      "name": "Sedan Car On Rent in Pune",
      description: "Looking to rent a sedan in Pune? AB Ghule Cabs offers a variety of well-maintained sedans for local and outstation travel. Whether you need a quick ride or a long-distance journey, we have the perfect sedan for your needs."
    },
    {
      "name": "Etios Car Rental Service",
      description: "Rent a Toyota Etios car with AB Ghule Cabs for a comfortable and budget-friendly travel experience in Pune. Our Etios cars are ideal for both local and outstation trips, offering ample space and excellent fuel efficiency."
    },
    {
      "name": "Swift Dzire On Rent in Pune",
      description: "Need a Swift Dzire on rent in Pune? AB Ghule Cabs offers Swift Dzire rentals for a smooth and comfortable ride. Whether you need it for a day trip or an extended journey, our rentals are available at competitive rates."
    },
    {
      "name": "Swift Dzire On Rent in Pune Near Me",
      description: "Find a Swift Dzire for rent near you in Pune with AB Ghule Cabs. We provide easily accessible and well-maintained Swift Dzire cars for your convenience, ensuring you travel in comfort to your destination."
    },
    {
      "name": "Swift Dzire Rent Per Km Rate",
      description: "Looking for the rent per km rate for a Swift Dzire in Pune? AB Ghule Cabs offers affordable and transparent pricing for Swift Dzire rentals, ensuring you get the best value for your money on both local and outstation trips."
    },
    {
      "name": "Sedan Cab Hire for Outstation",
      description: "AB Ghule Cabs provides sedan cab hire for outstation travel from Pune. Whether you’re traveling to nearby destinations or faraway cities, our sedan cabs offer comfort, reliability, and professional service."
    },
    {
      "name": "Sedan Taxi Service in Pune",
      description: "Book a sedan taxi in Pune with AB Ghule Cabs for reliable and comfortable travel. Our fleet of sedans is available for both local and outstation journeys, ensuring you reach your destination in comfort and style."
    },
    {
      "name": "Volkswagen Vento on Rent Pune",
      description: "For those seeking a premium experience, AB Ghule Cabs offers the Volkswagen Vento on rent in Pune. Whether for local trips or long-distance travel, the Vento offers a smooth ride with top-notch features."
    },
    {
      "name": "Toyota Etios Hire in Pune",
      description: "Hire a Toyota Etios car in Pune with AB Ghule Cabs for a comfortable and economical ride. The Etios is perfect for local travel, business trips, and outstation journeys, providing ample space and smooth performance."
    },
    {
      "name": "Pune to Mahabaleshwar Sedan Cabs",
      description: "Planning a trip to Mahabaleshwar? Rent a sedan cab from AB Ghule Cabs for a relaxing and comfortable ride from Pune to this beautiful hill station. Our fleet of sedans offers a smooth and efficient travel experience."
    },
    {
      "name": "Pune to Shirdi Sedan Cabs",
      description: "Book a sedan cab for your trip from Pune to Shirdi with AB Ghule Cabs. Whether you are traveling for a spiritual visit or a quick getaway, our sedan cabs ensure you reach Shirdi comfortably and on time."
    },
    {
      "name": "Pune to Shirdi Cabs Round Trip",
      description: "AB Ghule Cabs offers round-trip sedan cabs for your journey from Pune to Shirdi. Enjoy a hassle-free trip with our experienced drivers, who will ensure a timely and comfortable return to Pune after your visit."
    },
    {
      "name": "Pune Airport to Shirdi Sedan Cabs",
      description: "Travel from Pune Airport to Shirdi in a sedan with AB Ghule Cabs. Our professional drivers ensure a smooth and comfortable ride, making your airport transfer to Shirdi easy and stress-free."
    },
    {
      "name": "Pune to Goa Sedan Cabs",
      description: "Need a sedan for your trip from Pune to Goa? Rent a sedan from AB Ghule Cabs for a comfortable and stylish ride to Goa. Our vehicles are perfect for both short and long journeys, providing you with a reliable option for your travel needs."
    },
    {
      "name": "Pune to Mumbai Sedan Cabs",
      description: "Book a sedan cab for your trip from Pune to Mumbai with AB Ghule Cabs. Our sedans are ideal for this route, offering comfort, efficiency, and excellent service for a smooth ride to Mumbai."
    },
    {
      "name": "Volkswagen Vento Cabs on Rent",
      description: "Rent a Volkswagen Vento cab with AB Ghule Cabs for a premium travel experience. Whether you’re heading outstation or just need a taxi for local use, our Vento cabs offer luxury and comfort for any journey."
    },
    {
      "name": "Volkswagen Car Rental Services",
      description: "AB Ghule Cabs provides Volkswagen car rental services in Pune for a variety of needs. Rent a Volkswagen Vento or other Volkswagen models for a high-end, comfortable, and smooth ride to your desired destination."
    },
    {
      "name": "Volkswagen Vento Taxi",
      description: "Book a Volkswagen Vento taxi with AB Ghule Cabs for a top-tier taxi experience. Our Vento taxis are perfect for both local and outstation journeys, offering excellent comfort and a refined travel experience."
    },
    {
      "name": "Volkswagen Vento Taxi for Outstation",
      description: "Need a Volkswagen Vento for an outstation trip? AB Ghule Cabs offers Vento taxis for long-distance travel. Enjoy a luxurious and comfortable ride with a professional driver who knows the best routes."
    },
    {
      "name": "Volkswagen Vento Cab Booking for Outstation",
      description: "Book a Volkswagen Vento cab for your outstation trip with AB Ghule Cabs. Our Vento cabs are available for bookings to any outstation destination, offering comfort, style, and reliability for your journey."
    },
    {
      "name": "Volkswagen Vento Taxi Service",
      description: "AB Ghule Cabs provides Volkswagen Vento taxi services for all your travel needs in Pune. Whether you need a ride to the airport or an outstation journey, our Vento taxis offer the comfort and luxury you deserve."
    },
    {
      "name": "Volkswagen Vento Cab Booking",
      description: "Book your Volkswagen Vento cab easily with AB Ghule Cabs. Our user-friendly booking system makes it simple to reserve a Vento for local, outstation, or airport transfers, ensuring you travel with ease and comfort."
    },
    {
      "name": "Volkswagen Vento On Rent Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Mumbai to Shirdi Cab. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Sedan Car On Rent in Pune", "- Etios Car Rental Service"],
    ["Swift Dzire on Rent in Pune", "- Swift Dzire on Rent in Pune Near Me"],
    ["Swift Dzire Rent per km Rate", "- Sedan Cab Hire for Outstation"],
    ["Sedan Taxi Service in Pune", "- Volkswagen Vento on Rent Pune"],
    ["Toyota Etios Hire in Pune", "- Pune to Mahabaleshwar Sedan Cabs"],
    ["Pune to Shirdi Sedan Cabs", "- Pune to Shirdi Cabs Round Trip"],
    ["Pune Airport to Shirdi Sedan Cabs", "- Pune to Goa Sedan Cabs"],
    ["Pune to Mumbai Sedan Cabs", "- Volkswagen Vento Cabs on Rent"],
    ["Volkswagen Car Rental Services", "- Volkswagen Vento Taxi"],
    ["Volkswagen Vento Taxi for Outstation", "- Volkswagen Vento Cab Booking for Outstation"],
    ["Volkswagen Vento Taxi Service", "- Volkswagen Vento Cab Booking"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Stylish and Comfortable Ride",
      WhyChoosedescription: "The Volkswagen Vento offers a sleek, stylish, and comfortable ride, perfect for both business and leisure travel. With plush seating, ample legroom, and a smooth driving experience, it’s ideal for your next trip in and around Pune."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "Our Volkswagen Vento cars are meticulously maintained and regularly serviced to ensure they are in top condition. Clean, sanitized, and ready for your journey, our cars offer both comfort and reliability."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Safety is our priority. All our drivers are highly trained, experienced, and background-checked to ensure a smooth and secure ride. They are well-versed in city routes and provide timely, professional services throughout the journey."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive pricing for renting a Volkswagen Vento, with no hidden charges. Our fare structure is clear and affordable, ensuring you get great value for your money while enjoying a premium ride."
    },
    {
      WhyChooseheading: "Perfect for Business and Leisure",
      WhyChoosedescription: "Whether you’re traveling for work or pleasure, the Volkswagen Vento provides the ideal combination of comfort and style. Its modern features and smooth drive make it perfect for both short city commutes and longer trips."
    },
    {
      WhyChooseheading: "Flexible Rental Options",
      WhyChoosedescription: "We provide flexible rental options for all types of travel, whether you need the Vento for a few hours, a day, or a week. Our packages are customizable to suit your travel requirements and schedule."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking a Volkswagen Vento is simple and quick. You can make a reservation online via our website, through our mobile app, or by calling our customer service team for immediate assistance."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We are available 24/7 to cater to your travel needs, whether it’s early morning or late-night bookings. Our customer service is always ready to assist you in booking a ride at any time."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I rent a Volkswagen Vento?',
      answer: 'You can rent a Volkswagen Vento through our website, mobile app, or by contacting our customer service team. We offer an easy and quick booking process.',
    },
    {
      id: 'FAQ2',
      question: 'What is the seating capacity of the Volkswagen Vento?',
      answer: 'The Volkswagen Vento comfortably accommodates 4-5 passengers, making it an excellent choice for small group travel or business trips.',
    },
    {
      id: 'FAQ3',
      question: 'Is the Volkswagen Vento air-conditioned?',
      answer: 'Yes, all our Volkswagen Vento cars are fully air-conditioned to ensure a comfortable ride, regardless of the weather.',
    },
    {
      id: 'FAQ4',
      question: 'What is the cost of renting a Volkswagen Vento?',
      answer: 'The cost varies based on rental duration, distance, and other factors. We provide competitive rates with clear and upfront pricing, and no hidden charges.',
    },
    {
      id: 'FAQ5',
      question: 'Are your drivers experienced and professional?',
      answer: 'Yes, all our drivers are experienced, highly trained, and background-checked to ensure a safe, reliable, and comfortable journey.',
    },
    {
      id: 'FAQ6',
      question: 'Can I use the Volkswagen Vento for outstation trips?',
      answer: 'Yes, the Volkswagen Vento is perfect for outstation travel. We offer flexible rental packages for both local and long-distance trips.',
    },
    {
      id: 'FAQ7',
      question: 'How do I pay for my Volkswagen Vento rental?',
      answer: 'You can pay through cash, credit/debit card, or online payment via our mobile app. We offer multiple payment options for your convenience.',
    },
    {
      id: 'FAQ8',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can modify or cancel your booking via our website or app. You can also reach out to our customer service for assistance with any changes.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, depending on your travel needs. We always provide a clear breakdown of any extra charges before confirming your booking.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs different from other rental services?',
      answer: 'AB Ghule Cabs stands out with our commitment to customer satisfaction, premium vehicles like the Volkswagen Vento, professional drivers, and transparent pricing. We offer a reliable, comfortable, and personalized travel experience.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Anil Sharma',
      feedback: 'I rented the Volkswagen Vento from AB Ghule Cabs for a business trip, and I was very impressed. The car was clean, stylish, and comfortable, making the journey smooth and enjoyable. The driver was professional and punctual, and the entire process was hassle-free. I highly recommend their services!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Shreya Joshi',
      feedback: 'I rented a Volkswagen Vento for a weekend getaway with my family, and it was a great experience. The car was spacious and very comfortable, and the ride was smooth. AB Ghule Cabs provided excellent service, and I’ll definitely choose them for my future trips.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Volkswagen Vento on Rent in Pune | Sedan Car Rental & Cab Services</title>
  <meta name="description" content="Volkswagen Vento on rent in Pune. Offering sedan cars for local and outstation trips. Book online or call +91 8624029699 for Pune to Mahabaleshwar, Shirdi, Goa, and more." />
  <meta name="keywords" content="sedan car On Rent in Pune, Etios Car Rental Service, Swift Dzire on rent in Pune, Swift Dzire on rent in Pune near me, Swift Dzire rent per km rate, sedan cab hire for outstation, sedan taxi service in Pune, Volkswagen Vento on rent Pune, Toyota Etios Hire in Pune, Pune to Mahabaleshwar sedan cabs, Pune to Shirdi sedan cabs, Pune to Shirdi cabs round trip, Pune airport to Shirdi sedan cabs, Pune to Goa sedan cabs, Pune to Mumbai sedan cabs, Volkswagen Vento Cabs on Rent, Volkswagen Car Rental Services, Volkswagen Vento taxi, Volkswagen Vento taxi for outstation, Volkswagen Vento cab booking for outstation, Volkswagen Vento taxi service, Volkswagen Vento cab Booking" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Volkswagen Vento on Rent in Pune | Sedan Car Rental & Cab Services" />
  <meta property="og:description" content="Volkswagen Vento on rent in Pune. Offering sedan cars for local and outstation trips. Book online or call +91 8624029699 for Pune to Mahabaleshwar, Shirdi, Goa, and more." />
  <meta property="og:image" content="https://abghulecabs.com/images/volkswagen-vento-rent.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/volkswagen-vento-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Volkswagen Vento on Rent in Pune",
        description: "Volkswagen Vento on rent in Pune. Offering sedan cars for local and outstation trips. Book online or call +91 8624029699 for Pune to Mahabaleshwar, Shirdi, Goa, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/volkswagen-vento-on-rent-in-pune",
        "logo": "https://abghulecabs.com/images/volkswagen-vento-rent.jpg",
        "image": "https://abghulecabs.com/images/volkswagen-vento-rent.jpg",
        "priceRange": "₹2000 - ₹4000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/volkswagen-vento-on-rent-in-pune",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.6",
          "reviewCount": "95"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anjali R"
            },
            "datePublished": "2024-11-20",
            "reviewBody": "Rented a Volkswagen Vento for our trip to Shirdi. Comfortable ride and excellent service. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh P"
            },
            "datePublished": "2024-10-30",
            "reviewBody": "Great experience with AB Ghule Cabs! The Volkswagen Vento was perfect for our family trip to Mahabaleshwar. Clean and well-maintained."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune Volkswagen Vento Rentals",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/volkswagen-vento-on-rent-in-pune"
        },
        "keywords": "sedan car On Rent in Pune, Etios Car Rental Service, Swift Dzire on rent in Pune, Swift Dzire on rent in Pune near me, Swift Dzire rent per km rate, sedan cab hire for outstation, sedan taxi service in Pune, Volkswagen Vento on rent Pune, Toyota Etios Hire in Pune, Pune to Mahabaleshwar sedan cabs, Pune to Shirdi sedan cabs, Pune to Shirdi cabs round trip, Pune airport to Shirdi sedan cabs, Pune to Goa sedan cabs, Pune to Mumbai sedan cabs, Volkswagen Vento Cabs on Rent, Volkswagen Car Rental Services, Volkswagen Vento taxi, Volkswagen Vento taxi for outstation, Volkswagen Vento cab booking for outstation, Volkswagen Vento taxi service, Volkswagen Vento cab Booking"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/42.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Volsawagenventoonrent;